export default __webpack_public_path__ + "static/media/lzf.7c7cfaf4.png";